<div class="pinned-tiles-container" cdkDropListGroup>
  <div *ngIf="showAdd" class="tiles-container-add {{size}}" (click)="addClick()"><span class="fa-solid fa-plus-large"></span></div>
  <ng-template ngFor let-i="index" let-tile [ngForOf]="tiles">
    <app-tile cdkDropList [tile]="tile" [index]="i" [size]="size" [draggable]="draggable"
              [cdkDropListData]="{item:tile, index:i}" (cdkDropListDropped)="drop($event)"
              (ispinnedchange)="pinnedChange($event)" [tileTemplate]="{template:tileTemplate, context:{model:tile.data}}"></app-tile>
  </ng-template>
  <div cdkDropList class="tile-placeholder" (cdkDropListDropped)="drop($event)" [cdkDropListData]="{index:999}" ></div>
</div>
